import { _chips, CHIP_KEY } from '../config'
import type { IRewardData } from '../config.reward'
import { _rewards, REWARD_KEY } from '../config.reward'

export const isChipKey = (value: string): value is CHIP_KEY => {
  return Object.values(CHIP_KEY).includes(value as CHIP_KEY)
}
export function getChipKeyFromEncryptedId(
  encryptedId: string,
): CHIP_KEY | undefined {
  for (const key in _chips) {
    const chip = _chips[key as CHIP_KEY]
    if (chip.encryptedId === encryptedId) {
      return chip._id
    }
  }
  return undefined
}

export function getRewardByKey(key: string): IRewardData | undefined {
  if (Object.values(REWARD_KEY).includes(key as REWARD_KEY)) {
    return _rewards[key as REWARD_KEY]
  }
  return undefined
}
